const normalizeText = (text) =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const getCategories = (productos) => {
  const categories = new Set(
    productos
      .filter((producto) => producto?.active !== false)
      .map((producto) => producto.categoria || producto.category)
      .filter(Boolean)
  );

  return Array.from(categories).sort((a, b) => a.localeCompare(b, "es"));
};

export const filterProducts = (productos, filters) => {
  const query = normalizeText(filters.search || "");

  return productos.filter((producto) => {
    if (filters.category !== "all" && producto.categoria !== filters.category) {
      return false;
    }

    if (producto.active === false) {
      return false;
    }

    if (filters.availableOnly && !producto.disponible) {
      return false;
    }

    if (!query) return true;

    const haystack = normalizeText(
      `${producto.nombre} ${producto.descripcion} ${producto.categoria}`
    );

    return haystack.includes(query);
  });
};

export const sortProducts = (productos, sortKeyOrOptions, getPriceForProduct) => {
  const options =
    typeof sortKeyOrOptions === "string"
      ? {
          sortKey: sortKeyOrOptions,
          featuredFirst: sortKeyOrOptions === "todos",
          pricePriority:
            sortKeyOrOptions === "precio-asc" || sortKeyOrOptions === "precio-desc",
        }
      : {
          sortKey: sortKeyOrOptions?.sortKey,
          featuredFirst: sortKeyOrOptions?.featuredFirst === true,
          pricePriority: sortKeyOrOptions?.pricePriority === true,
        };

  const sorted = [...productos];
  const originalIndex = new Map(sorted.map((producto, index) => [producto, index]));

  sorted.sort((a, b) => {
    const fallback = (originalIndex.get(a) ?? 0) - (originalIndex.get(b) ?? 0);
    const priceA = getPriceForProduct(a);
    const priceB = getPriceForProduct(b);

    const compareByPrice = () => {
      if (options.sortKey === "precio-desc") return priceB - priceA;
      if (options.sortKey === "precio-asc") return priceA - priceB;
      return 0;
    };

    // Destacados primero (solo si se solicita)
    if (options.featuredFirst) {
      const destacadoA = a.destacado === true ? 1 : 0;
      const destacadoB = b.destacado === true ? 1 : 0;
      if (destacadoA !== destacadoB) {
        return destacadoB - destacadoA;
      }
      return fallback;
    }

    // Si el orden por precio est? activo, tiene prioridad (sin considerar destacados).
    if (options.pricePriority) {
      const byPrice = compareByPrice();
      return byPrice !== 0 ? byPrice : fallback;
    }

    const byPrice = compareByPrice();
    return byPrice !== 0 ? byPrice : fallback;
  });

  return sorted;
};
